import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
  import useIcons from '@/composables/useIcons'
  import useBreakpoint from '@/composables/useBreakpoint'
  import CarouselSwiper from '@/components/common/CarouselSwiper.vue'
  import Testimonial from '@/components/course/Testimonial.vue'
  import type { PropType } from 'vue'
  import type { Testimonial as TestimonialState } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TestimonialSlider',
  props: {
    testimonials: {
      required: true,
      type: Array as PropType<TestimonialState[]>,
    },
    slidesPerGroup: {
      default: 4,
      type: Number,
    },
    slidesPerView: {
      default: 3.35,
      type: Number,
    },
  },
  setup(__props) {

  

  const { leftNavigation, rightNavigation } = useIcons()
  const { isMobileDevice, isDesktopDevice } = useBreakpoint()

  const breakPoints = {
    1200: {
      slidesPerView: '2.35',
      spaceBetween: '30',
      slidesPerGroup: '2',
    },
    1024: {
      slidesPerView: '2.25',
      spaceBetween: '30',
      slidesPerGroup: '2',
    },
    991: {
      slidesPerView: '1.65',
      spaceBetween: '20',
      slidesPerGroup: '1',
    },
    767: {
      slidesPerView: '1.25',
      spaceBetween: '20',
      slidesPerGroup: '1',
    },
    540: {
      slidesPerView: '1.2',
      spaceBetween: '15',
      slidesPerGroup: '1',
    },
  }

  const rerenderKey = ref('')
  watch(isMobileDevice, () => {
    rerenderKey.value = Math.random().toString()
  })

return { __sfc: true,leftNavigation, rightNavigation, isMobileDevice, isDesktopDevice, breakPoints, rerenderKey, ref, watch, useIcons, useBreakpoint, CarouselSwiper, Testimonial }
}

})